<template>
	<v-overlay
		:model-value="visible"
		contained
		persistent
		scrim="primary"
		class="align-center justify-center border-md border-dashed rounded"
		data-test-id="media-grid-drop-overlay">
		<div class="d-flex flex-column align-center justify-center">
			<div class="drag-upload-overlay-icon text-medium-emphasis text-primary mb-2">
				<v-icon>icon-cloud-stroke-upload</v-icon>
			</div>
			<div class="drag-upload-overlay-text text-primary text-center font-weight-semibold">Drag and drop files here</div>
		</div>
	</v-overlay>
</template>

<script lang="ts" setup>
	// LSP-16659: the upload drop overlay the Documents tab used, now shown over the media grid.
	defineProps({
		visible: {
			type: Boolean,
			default: false
		}
	});
</script>

<style lang="scss" scoped>
	.drag-upload-overlay-icon {
		font-size: 2rem;
	}

	.drag-upload-overlay-text {
		font-size: 1.25rem;
	}
</style>
